<template>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <!-- Title -->
        <vue-headful :title="$t('Study department')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <!-- Фильтры -->
            <Sidebar :sidebarToggle="toggleSidebar" ref="ListFilters" @closeSidebar="closeSidebar" :itemHandler="infiniteHandle"/>
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">
            <!-- Поиск -->
            <div class="flex border d-theme-dark-bg items-center" >
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>
            </div>
            <div v-if="user.role.is_office || user.role.is_org_admin" class="px-6 py-4">
                <vs-button
                    @click="getExcelToken('statistic_of_courses')"
                    id="statistic_of_courses"
                    class="vs-con-loading__container ml-2"
                > {{$t('statistic_of_courses')}} </vs-button>
            </div>
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                @ps-y-reach-end="infiniteHandle"
                :key="$vs.rtl">
                <div v-if="GET_COURSE.results != 0">
                    <ul class="scroll-content">
                        <li class="todo_todo-item cursor-pointer"  >
                            <list-item :index="index" v-for="(item,index) in GET_COURSE.results" :item="item" :key="index"/>
                        </li>
                    </ul>
                </div>

                <!-- Выводим сообщение если данных нет -->
                <div v-else class="mt-4 ml-5 mr-5" >
                    <vs-alert active="true">
                        {{ $t('no_data_text') }}
                    </vs-alert>
                </div>
                <div id="infinite_loader" class="vs-con-loading__container"></div>
            </component>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from "vuex";
import Sidebar from "@/pages/Home/DisciplineRegistrationAccess/SideBar";
import ListItem from "@/pages/Home/DisciplineRegistrationAccess/body/ListItem";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            isSidebarActive: true,
            interval: false,
            intervalParams: {
                token: null,
                uid: null,
            },
            button_id: null,
        };
    },
    components: {
        ListItem,
        VuePerfectScrollbar,
        Sidebar
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        ...mapGetters({
            GET_COURSE:'discipline_registration_access/GET_COURSE',
        }),
        user() {
            return this.$store.state.user.user
        },
        windowWidth() { return this.$store.state.windowWidth },
        infiniteStatus: {
            get() {
                return this.$store.state.discipline_registration_access.infiniteStatus
            },
            set(value) {
                this.$store.commit("discipline_registration_access/SET_INF_STATUS", value)
            }
        },
        page: {
            get() {
                return this.$store.state.discipline_registration_access.page
            },
            set(value) {
                this.$store.commit("discipline_registration_access/SET_PAGE", value)
            }
        },
    },
    async created(){
        if(this.user.role.is_supervisor)
            this.$route.meta.pageTitle = 'list_of_recommended_courses'
        await this.STATUS_COURSE()
        await this.infiniteHandle({update:true})
        // await this.fetchDisciplines()
        this.setSidebarWidth()

    },
    beforeDestroy () {

    },
    methods: {
        ...mapMutations({
            SET_CLEAN_STATISTIC:'SET_CLEAN_STATISTIC'
        }),
        ...mapActions({
            fetchDisciplines:'discipline_registration_access/fetchDisciplines',
            STATUS_COURSE:'discipline_registration_access/STATUS_COURSE',
            STATISTICS_DISCIPLINE_REGISTRATION_ACCESS:'STATISTICS_DISCIPLINE_REGISTRATION_ACCESS',
        }),
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        },
        toggleSidebar (value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        },
        closeSidebar() {
            // Закрываем окно просмотра
            this.isViewSidebarActive = false
        },
        // нужен для обновления списка курсов когда меняется route query
        async infiniteHandle({update = false}) {
            //console.log(update)
            // Если update = true, запрашиваем список заново с новыми параметрами
            if(update) {
                this.infiniteStatus = true
                this.page = 0
            }
            // Запрашиваем список с выставленными параметрами
            if(!this.loading && this.infiniteStatus) {
                this.loading = true
                this.emptyMessage = false
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })
                try {
                    this.page = this.page+1
                    // Запрашиваем список
                    const res = await this.fetchDisciplines({page: this.page, route: this.$route})
                    await this.STATISTICS_DISCIPLINE_REGISTRATION_ACCESS({route: this.$route})

                    // Если на первой странице данных нет вообще, выводим сообщение
                    if(!res || this.page === 1 && !res.results.length) this.emptyMessage = true

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if(!res || !res.next) this.infiniteStatus = false
                    //console.log(res)
                } catch({detail}) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger',
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close('#infinite_loader > .con-vs-loading')
                }
            }
        },
        set_doc_type_for_query(query, button_id){
            if (button_id === 'statistic_of_courses' ){
                query.doc_type = '9'
                return query
            }
        },
        async getExcelToken(button_id) {
            // button_id - тип отчета
            if (!this.$route.query.study_year_filter||!this.$route.query.semester_filter){
                this.$vs.notify({
                    title: this.$t("study_year_and_semester_must_be_chosen"),
                    color: "primary",
                });
                return
            }

            this.button_id = button_id
            try {
                this.$vs.loading({
                    container: `#${ this.button_id }` ,
                    scale: 0.45,
                });
                let query = this.$route.query;

                query = this.set_doc_type_for_query(query ,button_id)

                const res = await this.$http.get(`reports/excel/reg_result/adviser/online_registration_for_courses/`, {
                    params: query,
                });
                if (res.status === 200) {
                    this.intervalParams = res.data;
                    this.intervalParams.get = "status";

                    this.$vs.notify({
                        title: this.$t("file_process"),
                        // time: 10000,
                        text: this.$t("some_time"),
                        color: "primary",
                        icon: "error",
                    });

                    // Чтобы дебаггер на беке не делал вам мозги, раскоментируйте это
                    // и закоментируйте нижнее
                    await this.sleep(5000);
                    await this.getStatus();

                    // Временно закомменчено на период разработки отчета. Неудобно было дебажить. Постоянно прилетал запрос.
                    // this.interval = setInterval(async () => {
                    //     await this.getStatus();
                    // }, 10000);
                }
            } catch (e) {}
        },
        async getStatus() {
            let res
            try{
                res = await this.$http.get("/reports/get_file/", {
                    params: this.intervalParams,
                });
            }catch (e){
                if (e.error.message ==='requirements_for_graduating_or_students_and_teachers_load_type_is_empty'){
                    this.$vs.notify({
                        title: this.$t('requirements_for_graduating_or_students_and_teachers_load_type_is_empty'),
                        text: e.error.item.profile.full_name,
                        color: 'danger',
                    })
                }else {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger',
                    })
                }
            }
            if (res.data.done) {
                clearInterval(this.interval);
                await this.downloadFile();
            }
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async downloadFile() {
            await this.$http
                .get("reports/get_file/", {
                    responseType: "blob",
                    params: { token: this.intervalParams.token, get: "file" },
                })
                .then((response) => {
                    // Создаю тег а виртуальный
                    const link = document.createElement("a");
                    // Добавляю к нему ссылку на закачку
                    link.href = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    // Устанавливаю к нему атрибуты названия файла и метод
                    link.setAttribute(
                        "download",
                        this.$t("statistic_of_courses") + ".xlsx"
                    );
                    // Вставляю/заменяю тег а в конце body
                    document.body.appendChild(link);
                    // Произвожу клик
                    link.click();
                });
            // console.log(`#${ this.button_id } > .con-vs-loading`);
            this.$vs.loading.close( `#${ this.button_id } > .con-vs-loading`);
            this.button_id = null
        },
    },
    destroyed() {
        this.SET_CLEAN_STATISTIC()
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    .infinite_alert{
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}

#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}

</style>
